import type {
  ActivityQuery,
  DeliveryViewQuery,
  GenerationViewQuery,
  GenerationQuery,
  LibraryTrackCardQuery,
  PlaylistOptionsQuery,
  PlaylistQuery,
  ProjectQuery,
  AllProjectCardsQuery,
  TrackCardQuery,
  TrackDetailQuery,
} from './resources.js';

export const queryKeys = {
  session: ['session'] as const,
  workspace: ['workspace'] as const,
  connections: (cursor?: string) => ['connections', cursor ?? null] as const,
  libraries: (cursor?: string) => ['libraries', cursor ?? null] as const,
  destinations: (cursor?: string) => ['destinations', cursor ?? null] as const,
  capabilities: (connectionId: string) => ['capabilities', connectionId] as const,
  presets: (connectionId: string) => ['presets', connectionId] as const,
  generationLifecycle: (connectionId: string) => ['generation-lifecycle', connectionId] as const,
  generation: (generationId: string, query: GenerationViewQuery) =>
    ['generation', generationId, query] as const,
  generations: (query: GenerationQuery) => ['generations', query] as const,
  projects: (query: Omit<ProjectQuery, 'cursor'>) => ['projects', query] as const,
  projectCards: (query: AllProjectCardsQuery) => ['project-cards', query] as const,
  project: (projectId: string) => ['project', projectId] as const,
  openingImpactAudit: (projectId: string, connectionId: string, libraryId: string) =>
    ['opening-impact-audit', projectId, connectionId, libraryId] as const,
  catalog: (query: TrackCardQuery) => ['catalog', query] as const,
  libraryTracks: (libraryId: string, query: LibraryTrackCardQuery) =>
    ['library-tracks', libraryId, query] as const,
  track: (trackId: string, query: TrackDetailQuery) => ['track', trackId, query] as const,
  import: (libraryId: string, importId: string) => ['import', libraryId, importId] as const,
  favoriteCommand: (commandId: string) => ['favorite-command', commandId] as const,
  playlists: (libraryId: string, query: PlaylistQuery) => ['playlists', libraryId, query] as const,
  playlist: (libraryId: string, playlistId: string) => ['playlist', libraryId, playlistId] as const,
  playlistItems: (libraryId: string, playlistId: string) =>
    ['playlist-items', libraryId, playlistId] as const,
  playlistOptions: (libraryId: string, trackId: string, query: PlaylistOptionsQuery) =>
    ['playlist-options', libraryId, trackId, query] as const,
  activity: (query: ActivityQuery) => ['activity', query] as const,
  synchronizations: (connectionId: string) => ['synchronizations', connectionId] as const,
  delivery: (requestId: string, query: DeliveryViewQuery) =>
    ['delivery', requestId, query] as const,
} as const;
